import { WatchLinkPage } from '@online-webinar/public';
import { RouterType } from '@online-webinar/router/src/router';

export const updateRoute = (router: RouterType) => {
    router.routesById['/w/$linkCode'].update({
        staticData: { title: { webinar: 'Title.WatchWebinar' } },
        component: WatchLinkPage
    });
};
